export const Id: unique symbol = Symbol('ClientIdProp');
export const UserId: unique symbol = Symbol('ClientUserIdProp');
export const Manager: unique symbol = Symbol('ClientManagerProp');
export const Pod: unique symbol = Symbol('ClientPodProp');
